module.exports = __webpack_public_path__ + "img/ic_logout.e9427d08.svg";